import PaymentWaiting from './PaymentCheck.page';

export default PaymentWaiting;
